<template>
    <div class="form-group mapContainer">
        <div class="google-map" ref="googleMap" v-bind:style="{ width: '100%', height: '400px' }"></div>
    </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'

export default {
    props: {
        apiKey: String,
        mapCoordinates: Array,
    },
    data () {
        return {
            mapConfig: {
                center: { lat: 45, lng: 23 },
                zoom: 6
            },
            google: null,
            map: null,
            coordinates: this.mapCoordinates,
            marker: null
        }
    },
    async mounted () {
        new Loader({
            apiKey: this.apiKey,
            version: "weekly",
            libraries: ["places"]
        }).load()
            .then(() => {
                this.google = google;
                this.initializeMap()
            })
            .catch(e => {
                console.log(e)
            });
    },

    methods: {
        initializeMap () {
            const mapContainer = this.$refs.googleMap
            this.map = new this.google.maps.Map(mapContainer, this.mapConfig)

            this.marker = new this.google.maps.Marker({
                map: this.map,
                anchorPoint: new this.google.maps.Point(0, -29),
                draggable: false,
                label: '',
                optimized: false,
                visible: false
            })
            const myLatlng = new this.google.maps.LatLng(this.coordinates[0], this.coordinates[1])
            this.loadMarker(myLatlng)
        },
        loadMarker (myLatlng) {
            this.marker.setVisible(true)
            this.marker.setPosition(myLatlng)
            this.map.setCenter(myLatlng)
            this.map.setZoom(17)
        },
    }
}
</script>
